var blockquote_default = {
  "fontElementMap": "NeRCw",
  "quoteContainer": "U65xw",
  "quote": "STqi9"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
